import React, { useState, useEffect,useContext  } from 'react';
import clientimg from '../assets/images/client.png'
import { Container, Row, Col } from "react-bootstrap";
import ReactMarkdown from 'react-markdown';
import { useNavigate, useLocation   } from 'react-router-dom';
import axios from 'axios';
import Loader from '../components/Loader';
import Navbar from './Navbar';
import { decryptString,encryptString  } from '../utils/commonFunctions';
import html2pdf from 'html2pdf.js';
import { UserContext } from '../contexts/UserContext';
import FeedbackWidget from '../components/FeedbackWidget';
import { CONFIG} from '../config';

//const client_demographics_web= {"client_demographics_web": {"Client Account Lead (CAL)": "roland.mayr", "Unified Account Lead (UAL)": "sharad.b.kumar.singh", "Global / Local TSL": "thi.long.thuan.tran / martin.felsch", "Diamond Client": "Yes", "Overall Risk/Issues": "**Information Security**: No specific risk/issues mentioned in the provided context.\n\n**Financial**: Amber status, wrong booking in Feb, impact on CCI, SAP EAC higher than Actual CTD, overall revenue from backlog underperformance, optimization in financial forecasting for sub-contractors, financial status amber, CY1 closed at 23%, FY25 planned landing at 23.3%, EAC gaps, budget consumption accuracy, high payroll cost and reduced revenue, increased costs due to team ramp up & KT, budget pressure from BMW, high front-loading in delivery, CTD costs higher compared to CTAIPB, ongoing discussions of maintenance offer.\n\n**Client Satisfaction**: No specific risk/issues mentioned in the provided context.\n\n**Delivery**: Velocity too low, spillover not finished in January, difficulty finding senior and appropriate skills, delivery in other sub-products is stable, quality of delivery needs improvement, defects due to coding error or design flaw, product ECMDelivery status yellow, ABT delivery still in stabilization, recent attrition impacting delivery timeline, historical knowledge lost, extensive ramp-up time, gAMS delivery with spill-overs, PLRSdelivery status is good, risk on dependency to Heirloom transpilation tool, ongoing negotiations with BMW impacting timeline, cost, and quality, performance issues with CCELM migration, safety development way behind plan, high risk of not delivering all safety-related topics, development of tests and testing way behind plan.\n\n**People/Resources**: Still searching for Mainframe, ABAP, and BW Developers, high team attrition, difficulty finding appropriate skills, three off-shore team members offboarded in February, staffing in progress for 1 mid/senior ABAP Dev, BMW budget challenges impacting resource utilization and planning to reduce team size, another IPB security developer resigned, a further low-level developer also resigned, most important low-level developer also resigned, high risk of not being able to deliver beginning of Q2/2025, no plan to compensate leave of APP1 key developer.\n\n**Contract Management**: No specific risk/issues mentioned in the provided context.\n\nSummary: Financial challenges, delivery issues, and people/resources constraints are impacting the contract. Client satisfaction and contract management do not have specific risk/issues mentioned.", "Overall Risk/Issues1": "**Financial**:\n - Amber status, wrong booking in Feb, impact on CCI, SAP EAC higher than Actual CTD, overall revenue from backlog underperformance, optimization in financial forecasting for sub-contractors, financial status amber, CY1 closed at 23%, FY25 planned landing at 23.3%, EAC gaps, budget consumption accuracy, high payroll cost and reduced revenue, increased costs due to team ramp up & KT, budget pressure from BMW, high front-loading in delivery, CTD costs higher compared to CTAIPB, ongoing discussions of maintenance offer.\n\n**Delivery**:\n - Velocity too low, spillover not finished in January, difficulty finding senior and appropriate skills, delivery in other sub-products is stable, quality of delivery needs improvement, defects due to coding error or design flaw, product ECMDelivery status yellow, ABT delivery still in stabilization, recent attrition impacting delivery timeline, historical knowledge lost, extensive ramp-up time, gAMS delivery with spill-overs, PLRSdelivery status is good, risk on dependency to Heirloom transpilation tool, ongoing negotiations with BMW impacting timeline, cost, and quality, performance issues with CCELM migration, safety development way behind plan, high risk of not delivering all safety-related topics, development of tests and testing way behind plan.\n\n**People/Resources**:\n - Still searching for Mainframe, ABAP, and BW Developers, high team attrition, difficulty finding appropriate skills, three off-shore team members offboarded in February, staffing in progress for 1 mid/senior ABAP Dev, BMW budget challenges impacting resource utilization and planning to reduce team size, another IPB security developer resigned, a further low-level developer also resigned, most important low-level developer also resigned, high risk of not being able to deliver beginning of Q2/2025, no plan to compensate leave of APP1 key developer.", "Overall Summary": "Contracts: DevOps ItO_008 EBOM, BMW CRM Retail - DOFC CRM FG140 OtODtCC11, DevOps ECM, Central Ordering, ESR_IP Basis have observed risks or issues. The risks or issues observed among these contracts are related to Financials, Delivery, People/Resources, and Contract Management.", "e2eList": [{"Contract ID / Opp ID": "9940338503", "E2E ID | End To End Name": "304364 | DevOps ItO_008 EBOM", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "At Risk$Amber", "Contract Management Status": "Good$Green"}, {"Contract ID / Opp ID": "9940390148", "E2E ID | End To End Name": "372255 | BMW CRM Retail - DOFC CRM FG140 OtODtCC11", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "At Risk$Amber", "Contract Management Status": "Good$Green"}, {"Contract ID / Opp ID": "9940313756", "E2E ID | End To End Name": "261959 | DevOps ECM", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "Good$Green", "Contract Management Status": "Not Reported$Grey"}, {"Contract ID / Opp ID": "9940454817", "E2E ID | End To End Name": "436601 | Central Ordering", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "Good$Green", "People/Resources Status": "At Risk$Amber", "Contract Management Status": "Good$Green"}, {"Contract ID / Opp ID": "9940406048", "E2E ID | End To End Name": "386612 | ESR_IP Basis", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "Good$Green", "Information Security Status": "Good$Green", "Financial Status": "Alert$Red", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "Alert$Red", "Contract Management Status": "Good$Green"}]}, "summary": ""};

//const client_demographics=client_demographics_web.client_demographics_web.e2eList;


const columns = ["Contract ID / Opp ID", "E2E ID | End To End Name","Market | MU or IG | Industry","Review Tag","Overall","Client Satisfaction","Delivery","Financial","People / Resources","Information Security","Contract Management"];
const genAIcolumns = ["Contract ID / Opp ID", "E2E ID | End To End Name","Market | MU or IG | Industry","Review Tag","Involved Service Groups","Committed | Scaled","Gen AI RAG (Committed)","GenAI Planned Productivity ($)","GenAI Realized Productivity ($)"];

function displayStatusColor(value){
  let parts = value.split('$');
  var status='';
  switch (parts[1]) {
    case "Green":
      status='green-circle';
      break;
    case "Amber":
      status='orange-circle';
      break;
    case 'Red':
      status='red-circle';
      break;
    case 'Grey':
      status='grey-circle';
      break;
    default:
      status='grey-circle';
  }
  return status
}

const Client = () => {
    const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/classifier_retrieval';
    //const apiUrl='https://divadevfalcon.azurewebsites.net/classifier_retrieval';
    console.log('apiurl',apiUrl);
    const location = useLocation();
    const fullPath = location.pathname; 
    const encryptedId = fullPath.replace("/client/", "");
    const [filterColumn, setFilterColumn] = useState(null);
    const [genAIFilterColumn, setGenAIFilterColumn] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [genAIModalOpen, setGenAIModalOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [genAISearchText, setGenAISearchText] = useState("");
    const [userId, setUserId] = useState("");
    const [clientName, setClientName] = useState("");
    const [selectedOptions, setSelectedOptions] = useState({});
    const [selectedGenAIOptions, setSelectedGenAIOptions] = useState({});
    const [allSelected, setAllSelected] = useState(false);
    const [genAIAllSelected, setGenAIAllSelected] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [genAIFilteredData, setGenAIFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [clientDemographicsWeb, setClientDemographicsWeb] = useState([]);
    const [displayCol, setdisplayCol] = useState(["Contract ID / Opp ID", "E2E ID | End To End Name","Market | MU or IG | Industry","Review Tag"]);
    const [genAIDisplayCol, setGenAIDisplayCol] = useState(["Contract ID / Opp ID", "E2E ID | End To End Name","Market | MU or IG | Industry","Review Tag","Involved Service Groups","Gen AI RAG (Committed)","Committed | Scaled","GenAI Planned Productivity ($)","GenAI Realized Productivity ($)"]);
    //const [genAIDisplayCol, setGenAIDisplayCol] = useState([]);
    const [sortColumn, setSortColumn] = useState(''); // name or status
    const [genAISortColumn, setGenAISortColumn] = useState(''); 
    const [error, setError] = useState("");
    const colorPriority = { "red-circle": 1, "orange-circle": 2, "green-circle": 3, "gray-circle": 4 };
    const navigate = useNavigate();
    const { clientContext, setClientContext } = useContext(UserContext);
    const [showFeedback, setShowFeedback] = useState(true);
    const [hasCommittedData,setHasCommittedData]=  useState(true);
    
    
   
    useEffect(() => {
      if(encryptedId){
        fetchData(encryptedId);
      }
      const handleClickOutside = (e) => {
        if (!e.target.closest(".filter-popup") && !e.target.closest(".filter-icon")) {
          setModalOpen(false);
          setGenAIModalOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };      
    }, []);


    // const decryptString = (encryptedString) => {
    //   let base64 = encryptedString.replace(/-/g, "+").replace(/_/g, "/");

    // // Add padding back if needed
    // while (base64.length % 4 !== 0) {
    //   base64 += "=";
    // }

    // // Base64 decode
    // const decoded = atob(base64);

    // // Reverse character shift by -3
    // const originalString = decoded
    //   .split("")
    //   .map((char) => String.fromCharCode(char.charCodeAt(0) - 3))
    //   .join("");

    // return JSON.parse(originalString);
    
    // };


    // const encryptString = (obj) => {
    //   // Convert Object to JSON String
    //   let jsonString = JSON.stringify(obj);
      
    //   // Encode to Base64
    //   let base64Encoded = btoa(jsonString);
      
    //   // Shift characters forward by 3
    //   let shiftedString = base64Encoded
    //     .split("")
    //     .map(char => String.fromCharCode(char.charCodeAt(0) + 3))
    //     .join("");
      
    //   // URL Encode
    //   return encodeURIComponent(shiftedString);
    // };

function displayRagColour(value) {
  console.log("value:", value);

  // Handle null, undefined, empty or whitespace
  if (!value || value.toString().trim() === "") {
    return "NA"; // default (Grey)
  }

  // If contains '$', take the part after '$'
  let result = value.includes('$') ? value.split('$')[1] : value;

  // Normalize value: trim + proper case
  result = result.trim();
  let cleaned = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();

  const colourMap = {
    "Green": "🟢",
    "Red": "🔴",
    "Amber": "🟡",
    "Grey": "🔘"
  };

  return colourMap[cleaned] || "NA";
}
const getgiFilteredData= (client_demographics_web) =>{
        let copyJson = JSON.parse(JSON.stringify(client_demographics_web.e2eList));
      var finalJson=[];
      copyJson.forEach(item => {
        finalJson = copyJson.filter(o => o['Committed vs Scaled']?.toString().trim() || o['Realized GenAI Productivity ($)']?.toString().trim() || o['GenAI Planned Productivity ($)']?.toString().trim()|| o['GenAI Realized Productivity ($)']?.toString().trim());
      });
      return finalJson;  
}

const joinArray = (arr)=> {
  if (!Array.isArray(arr) || arr.length === 0) {
    return '';
  }
  return arr.join(",");
}

    

    const fetchData = async (id) => {
      try{
      const postData=decryptString((id));      
      console.log('request json',postData);
      if(postData && postData.clientName && clientContext && clientContext[postData.clientName]) { 
        console.log('inside context'); 
          if (typeof clientContext[postData.clientName] === "string") {
           clientContext[postData.clientName] = clientContext[postData.clientName].replace(/NaN/g, "null");
           clientContext[postData.clientName]= JSON.parse(clientContext[postData.clientName]);
        }      
      setUserId(postData.enterprise_id);
      setClientName(postData.clientName);
      setClientDemographicsWeb(clientContext[postData.clientName]);
      setFilteredData(clientContext[postData.clientName].client_demographics_web.e2eList);  
      setHasCommittedData(hasValidCommittedValue(clientContext[postData.clientName].client_demographics_web.e2eList));
      var finalJson=getgiFilteredData(clientContext[postData.clientName].client_demographics_web);
      setGenAIFilteredData(finalJson);     
      } else {
        console.log('outside context');
      postData.query='client_demographics';
      postData.query_type='client_demographics_web';
      postData.startdate='';
      postData.enddate='';
      postData.tmsName='';
      postData.e2eName='';
      postData.custom_search='False';
      setUserId(postData.enterprise_id);
      setClientName(postData.clientName);

      await axios.post(apiUrl, postData)
      .then(response => {
        console.log('response',response);
         if (typeof response.data === "string") {
           response.data = response.data.replace(/NaN/g, "null");
           response.data= JSON.parse(response.data);
        }
        setClientDemographicsWeb(response.data);
        response.data.client_demographics_web.e2eList.forEach(item => {
          for (let key in item) {
            if(key==="Overall Status"){
              item.Overall=displayStatusColor(item["Overall Status"]);
            } else if(key==="Delivery Status"){
              item.Delivery=displayStatusColor(item["Delivery Status"]);
            } else if(key==="Financial Status"){
              item.Financial=displayStatusColor(item["Financial Status"]);
            } else if(key==="People/Resources Status"){
              item['People / Resources']=displayStatusColor(item["People/Resources Status"]);
            } else if(key==="Information Security Status"){
              item['Information Security']=displayStatusColor(item["Information Security Status"]);
            } else if(key==="Contract Management Status"){
              item['Contract Management']=displayStatusColor(item["Contract Management Status"]);
            } else if(key==="Client Satisfaction Status"){
              item['Client Satisfaction']=displayStatusColor(item["Client Satisfaction Status"]);
            } else if(key==="Market | Market Unit | CSG"){
              item['Market | MU or IG | Industry']=item["Market | Market Unit | CSG"];
            } else if(key==="Planned Gen AI Productivity ($)"){
               item['GenAI Planned Productivity ($)']=item["Planned Gen AI Productivity ($)"];        
            } else if(key==="Realized Gen AI Productivity ($)"){
               item['GenAI Realized Productivity ($)']=item["Realized Gen AI Productivity ($)"];        
            } else if(key==='Committed | Scaled '){
               item['Committed vs Scaled']=item["Committed | Scaled "];
               item['Committed | Scaled']=item["Committed | Scaled "];
            } else if(key==='rag'){
               item['Gen AI RAG (Committed)']=displayRagColour(item["rag"]);
            } else if(key==='Involved Service Groups'){
               item['Involved Service Groups']=joinArray(item["Involved Service Groups"]);
            } else if(key==='Review Tag'){
               item['Review Tag'] = item["Review Tag"]=="None"? "--":item["Review Tag"];
            }            
          }
        });
        console.log('response',response);
        setFilteredData(response.data.client_demographics_web.e2eList);
        console.log('test',response.data.client_demographics_web.e2eList);
        const val=hasValidCommittedValue(response.data.client_demographics_web.e2eList);
        console.log('val',val);
        setHasCommittedData(hasValidCommittedValue(response.data.client_demographics_web.e2eList));
        var finalJson=getgiFilteredData(response.data.client_demographics_web);
        setGenAIFilteredData(finalJson);
        setClientContext(prev => ({
          ...prev,
          [postData.clientName]: response.data
        }));
      }).catch(error => {
        console.error('Error posting data:', error);
        setError("Failed to fetch data.");
      });  
    }
      
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    } 
    }

    const handlePdfDownload = async () => {
        setLoading(true);
        const container = document.createElement('div');
        const ids = ['clientHeader','image-container', 'about', 'clientLevelSummary','pills-contract_details-tab','pills-contract_details','pills-key_risks-tab', 'pills-key_risks'];
        const originalStyles = [];
        ids.forEach(id => {
          const element = document.getElementById(id);
          if (element) {
            const tabpanel=['pills-contract_details','pills-key_risks'];            
            if(tabpanel.includes(id)){
              console.log('inside');
            }
            if(tabpanel.includes(id) && !element.classList.contains('active')){
               originalStyles.push(element);
               element.classList.add('show','active');
            }
            const clone = element.cloneNode(true);
           // clone.style.pageBreakInside = 'avoid';
            const toRemoveById = ['sortDiv','diva-userguide'];
            toRemoveById.forEach(rid => {
              const el = clone.querySelector(`#${rid}`);
              if (el) el.remove();
            });

             
            // //  Remove elements by class
             const toRemoveByClass = clone.querySelectorAll('.bi-filter');
              toRemoveByClass.forEach(el => el.remove());
    
            clone.style.marginBottom = '20px';
            container.appendChild(clone);
          }
        });
        const newElement = document.createElement('div');
        newElement.style.marginTop = '20px';
        newElement.style.fontSize = '14px';
        newElement.style.fontWeight = 'bold';                 
        newElement.style.color = '#A100FF';                 
        newElement.style.textAlign = 'center';                 
        newElement.innerText = 'Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.'; 
        container.appendChild(newElement);
            
        
        const options = {
          margin: 0.5,
          filename: clientName+'.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true,
          },
          jsPDF: {
            unit: 'in',
            format: 'a3', // landscape format
            orientation: 'landscape'
          },pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
        };
        originalStyles.forEach(el  => {
          el.classList.remove('show','active');
        });
        html2pdf().set(options).from(container).save();
        setLoading(false);
      };
    
    
    const handleSort = (column) => {
      setSortColumn(column);
  
      const sortedData = [...filteredData].sort((a, b) => {
        if (displayCol.includes(column)) {
          return a[column].localeCompare(b[column], undefined, { numeric: true, sensitivity: "base" });
        } else {
          return (colorPriority[a[column]] || 99) - (colorPriority[b[column]] || 99); // custom color sort
        }
      });
  
      console.log('sortedData',sortedData);
      setFilteredData(sortedData);
    };

      const handleGenAiSort = (column) => {
      setGenAISortColumn(column);
  
      const sortedGenAIData = [...genAIFilteredData].sort((a, b) => {
        if (genAIDisplayCol.includes(column)) {
          return a[column].localeCompare(b[column], undefined, { numeric: true, sensitivity: "base" });
        } else {
          return (colorPriority[a[column]] || 99) - (colorPriority[b[column]] || 99); // custom color sort
        }
      });
  
      console.log('sortedGenAIData',sortedGenAIData);
      setGenAIFilteredData(sortedGenAIData);
    };

    const handleGenAIFilterClick = (column) => {
      setGenAIFilterColumn(column);
      setGenAISearchText("");
      setGenAIModalOpen(true);
    };  

  
    const handleGenAISelectAll = () => {
      const options = getGenAIUniqueOptions();
      const newSelected = {};
      if (!genAIAllSelected) {
        options.forEach((option) => {
          newSelected[option] = true;
        });
      }
      setSelectedGenAIOptions(newSelected);
      setGenAIAllSelected(!genAIAllSelected);
    };
  
    const handleFilterClick = (column) => {
      setFilterColumn(column);
      setSearchText("");
      setModalOpen(true);
    };
  
    const handleCheckboxChange = (value) => {
      setSelectedOptions((prev) => ({
        ...prev,
        [value]: !prev[value],
      }));
    };

    const handleGenAICheckboxChange = (value) => {
      setSelectedGenAIOptions((prev) => ({
        ...prev,
        [value]: !prev[value],
      }));
    };


    const handleSelectAll = () => {
      const options = getUniqueOptions();
      const newSelected = {};
      if (!allSelected) {
        options.forEach((option) => {
          newSelected[option] = true;
        });
      }
      setSelectedOptions(newSelected);
      setAllSelected(!allSelected);
    };
  
    const displayColumnsData = (col,value) =>{
      if(displayCol.includes(col))
        return value;
      else return '';
    }
    const displayGenAIColumnsData = (col,value) =>{
      if(genAIDisplayCol.includes(col))
        return value;
      else return '';
    }
    const handleRowClick = (client) => {
      console.log('client',client);
      const reqObj={};
      reqObj.e2eName=(client['E2E ID | End To End Name'].split("|")[1]).trim();
      reqObj.enterprise_id=userId;
      reqObj.clientName=clientName;
      reqObj.contractID=client['Contract ID / Opp ID'];
      reqObj.clientUrl=encryptedId;
      const contractEncryptString=encryptString(reqObj);
      console.log('contractEncryptString',contractEncryptString);
      // Navigate to another page
      navigate(`/contact/${contractEncryptString}`);
    };

    const handleGenAIRowClick=() =>{
      console.log('inside');
    } 
  
    const handleApply = () => {
      if (!filterColumn) return;
  
      const selectedValues = Object.keys(selectedOptions).filter((key) => selectedOptions[key]);
  
      if (selectedValues.length === 0) {
        setFilteredData(clientDemographicsWeb.client_demographics_web.e2eList); // No filter, show all
      } else {
        const newFilteredData = clientDemographicsWeb.client_demographics_web.e2eList.filter((row) =>
          selectedValues.includes(row[filterColumn]?.toString())
        );
        setFilteredData(newFilteredData); //  Update filtered data
      }
      setModalOpen(false);
    };

        const handleGenAIApply = () => {
      if (!genAIFilterColumn) return;
  
      const selectedValues = Object.keys(selectedGenAIOptions).filter((key) => selectedGenAIOptions[key]);
  
      if (selectedValues.length === 0) {
        let finalJson=getgiFilteredData(clientDemographicsWeb.client_demographics_web);      
        setGenAIFilteredData(finalJson); // No filter, show all
      } else {
         let finalJson=getgiFilteredData(clientDemographicsWeb.client_demographics_web);      
        const newFilteredData = finalJson.filter((row) =>
          selectedValues.includes(row[genAIFilterColumn]?.toString())
        );
        setGenAIFilteredData(newFilteredData); //  Update filtered data
      }
      setGenAIModalOpen(false);
    };
  
    const getUniqueOptions = () => {
      if (!filterColumn) return [];
      const options = [...new Set(clientDemographicsWeb.client_demographics_web.e2eList.map((item) => item[filterColumn]))];
      return options.filter((option) =>
        (option ?? "").toString().toLowerCase().includes(searchText.toLowerCase())
      );
    };

    const getGenAIUniqueOptions = () => {
      if (!genAIFilterColumn) return [];
      let finalJson=getgiFilteredData(clientDemographicsWeb.client_demographics_web);
      const options = [...new Set(finalJson.map((item) => item[genAIFilterColumn]))];
      return options.filter((option) =>
        (option ?? "").toString().toLowerCase().includes(genAISearchText.toLowerCase())
      );
    };

//     const getReviewTagClass = (value) => {
//   if (!value) return "";

//   const v = value.toLowerCase();

//   if (["ppj", "eri", "focus job", "focusjob"].some(k => v.includes(k))) {
//     return "At Risk";
//   }
//   if (v === "pj") {
//     return "Alert";
//   }
//   return "";
// };




    const hasValidCommittedValue = (data) => {
  return Array.isArray(data) &&
    data.some(item =>
      item &&
      typeof item === "object" &&
      typeof item['Committed | Scaled '] === "string" &&
      item['Committed | Scaled '].trim() !== "" &&
      item['Committed | Scaled '].toLowerCase() !== "none"
    );
};


    const titleMap = {
      'green-circle': 'Good',
      'orange-circle': 'At Risk',
      'red-circle': 'Alert',
      'grey-circle': 'Not Reported',
    };

    if (error) { navigate(`/error`) }
  return (
    <div className="container">
      <Navbar />
      <div className='image-container' id='image-container'>
      <img src={clientimg}  alt="diva" className="client-img" />  
      <div className='text-overlay'>{clientName.toUpperCase()}</div>
      </div>
      <Container className="mt-4 totalClient" id='totalClient'>
      {/* Top Section with About & Export Button */}
      <Row className="align-items-center mb-3">
        <Col md={6} id='about'>
          <h3>About</h3>
        </Col>
        <Col md={6} className="text-end">
        <div className="btn-group export-btn" role="group">
          <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href="#" onClick={handlePdfDownload}>PDF</a></li>
            {/* <li><a className="dropdown-item" href="#">PDF</a></li> */}
          </ul>
        </div>
        </Col>
      </Row>
      <div className='d-flex justify-content-between'>
      <div className='p-2'></div>
      <div className='p-2'>
      <span>Data Source: MMD as on </span><span className='totalscr'>{clientDemographicsWeb?.client_demographics_web?.last_sunday}</span>
      </div>
      </div>
      {/* Gray Background Box */}
      <div className="p-3 bg-light rounded" id="clientLevelSummary">
        <h5 className='summaryTypeHeading'>Client level summary</h5>
        <table>
  <tbody className="container mt-4">
    <tr>
      <td className="col-6 col-md-4 width18 text-start">Client Account lead (CAL):</td>
      <td className="col-6 col-md-4 text-start">{clientDemographicsWeb && clientDemographicsWeb.client_demographics_web && clientDemographicsWeb.client_demographics_web['Client Account Lead (CAL)']? clientDemographicsWeb.client_demographics_web['Client Account Lead (CAL)']:''}</td>
      <td className="col-6 col-md-4 width18 text-start">Global/ Local TSL:</td>
      <td className="col-6 col-md-4 text-start">{clientDemographicsWeb && clientDemographicsWeb.client_demographics_web && clientDemographicsWeb.client_demographics_web['Global / Local TSL']? clientDemographicsWeb.client_demographics_web['Global / Local TSL'] : ''}</td>
    </tr>
    <tr>
      <td className="col-6 col-md-4 width18 text-start">Unified Account Lead (UAL):</td>
      <td className="col-6 col-md-4 text-start">{clientDemographicsWeb && clientDemographicsWeb.client_demographics_web && clientDemographicsWeb.client_demographics_web['Unified Account Lead (UAL)']? clientDemographicsWeb.client_demographics_web['Unified Account Lead (UAL)']:''}</td>
      <td className="col-6 col-md-4 width18 text-start">Diamond Client:</td>
      <td className="col-6 col-md-4 text-start">{clientDemographicsWeb && clientDemographicsWeb.client_demographics_web && clientDemographicsWeb.client_demographics_web['Diamond Client']?clientDemographicsWeb.client_demographics_web['Diamond Client']:''}</td>
    </tr>
    <tr>
      <td className="col-6 col-md-4 width18 text-start">Dominant Service Group:</td>
      <td className="col-6 col-md-4 text-start">{clientDemographicsWeb && clientDemographicsWeb.client_demographics_web && clientDemographicsWeb.client_demographics_web['Dominant Service Group']? clientDemographicsWeb.client_demographics_web['Dominant Service Group']:''}</td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>

      </div>

      <ul className="nav nav-pills mb-3 displayTab" id="pills-tab" role="tablist">
      <li className="nav-item" role="presentation">
        <button className="nav-link active" id="pills-contract_details-tab" data-bs-toggle="pill" data-bs-target="#pills-contract_details" type="button" role="tab" aria-controls="pills-contract_details" aria-selected="true">Contract Details</button>
      </li>
      <li className="nav-item" role="presentation">
        <button className="nav-link" id="pills-key_risks-tab" data-bs-toggle="pill" data-bs-target="#pills-key_risks" type="button" role="tab" aria-controls="pills-key_risks" aria-selected="false">Key Risks</button>
      </li>
      { hasCommittedData && 
      ( <li className="nav-item" role="presentation">
        <button className="nav-link" id="gen_ai_status-tab" data-bs-toggle="pill" data-bs-target="#gen_ai_status" type="button" role="tab" aria-controls="gen_ai_status" aria-selected="false">Gen AI Status</button>
      </li>)}
      </ul>
    <div className="tab-content clientNameTab" id="pills-tabContent">
      <div className="tab-pane fade show active" id="pills-contract_details" role="tabpanel" aria-labelledby="pills-contract_details-tab">
      <div className="container">
      <div className="sortDiv" id="sortDiv">
      <label>Sort</label>
      <select onChange={(e) => handleSort(e.target.value)} value={sortColumn}>
        <option value="Overall" >Overall</option>
        <option value="Contract ID / Opp ID">Contract ID / Opp ID</option>
        <option value="E2E ID | End To End Name">E2E ID | End To End Name</option>
        <option value="Market | MU or IG | Industry">Market | MU or IG | Industry</option>         
        <option value="Review Tag">Review Tag</option>         
        <option value="Delivery">Delivery</option>
        <option value="Financial">Financial</option>
        <option value="People / Resources">People/Resources</option>
        <option value="Information Security">Information Security</option>
        <option value="Contract Management">Contract Management</option>
      </select>
      </div>
      <div className="table-wrapper" id="table-wrapper">
      <table className="table table-bordered smart-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col} className="position-relative">
                <div className="d-flex align-items-center justify-content-between">
                  {col}
                  {displayCol.includes(col) && (
                  <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => handleFilterClick(col)}></i>
                )}
                  </div>

                {modalOpen && filterColumn === col && (
                  <div
                    className="border p-2 bg-white shadow-sm position-absolute filter-popup"
                    style={{
                      top: "100%",
                      left: "0",
                      width: "250px",
                      zIndex: 1050,
                    }}
                  >
                    <div className="mb-2 fw-bold">{`Filter ${col}`}</div>
                    <div class="input-container">
                        <input
                          type="text"
                          className="form-control mb-2 input-underline"
                          placeholder="Search..."
                          value={searchText}
                          class="input-underline"
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <i class="bi bi-search search-icon"></i> 
                     </div>
                    <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={allSelected}
                        onChange={handleSelectAll}
                      />
                      <label className="form-check-label selectAllLabel" htmlFor="selectAll">
                        Select All
                      </label>
                    </div>
                    <hr/>
                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {getUniqueOptions().map((option, idx) => (
                        <div className="form-check" key={idx}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            class="selectAllInput"
                            id={`check-${option}`}
                            checked={!!selectedOptions[option]}
                            onChange={() => handleCheckboxChange(option)}
                          />
                          <label
                            className="form-check-label selectAllLabel"
                            htmlFor={`check-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setModalOpen(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {filteredData.map((row, idx) => (
            <tr key={idx} className='clienttr' onClick={() => handleRowClick(row)}>
                  {columns.map((col) => {
                    let cellValue = row[col];
                    let className = displayColumnsData(col,row[col]); // assuming "Green" or "green"
                    console.log('className',className);
                    const title = titleMap[cellValue] || '';
                    console.log('title',title);
                    
                    return (
                      <td key={col} className={cellValue} title={title}>
                        {className}
                      </td>
                    );
                  })}
            </tr>           
          ))}
        </tbody>
      </table>
      </div>
    </div>
        </div>
      <div className="tab-pane fade" id="pills-key_risks" role="tabpanel" aria-labelledby="pills-key_risks-tab">
        
        <h5 className='accentureColor'>Overall Summary</h5>
        <div>
        <ReactMarkdown>
          {clientDemographicsWeb && clientDemographicsWeb.client_demographics_web && clientDemographicsWeb.client_demographics_web['Overall Summary']?clientDemographicsWeb.client_demographics_web['Overall Summary']:''}
        </ReactMarkdown>
        </div>
        <br/>
        <h5 className='accentureColor'>Overall Risk/Issue</h5>
        <div>
        <ReactMarkdown>
          {clientDemographicsWeb && clientDemographicsWeb.client_demographics_web && clientDemographicsWeb.client_demographics_web['Overall Risk/Issues1']?clientDemographicsWeb.client_demographics_web['Overall Risk/Issues1']:''}
        </ReactMarkdown>
        </div>
       
      </div>
      <div className="tab-pane fade" id="gen_ai_status" role="tabpanel" aria-labelledby="gen_ai_status-tab">
      <div className="container">
      {/* <div className="sortDiv" id="sortDiv">
      <label>Sort</label>
      <select onChange={(e) => handleGenAiSort(e.target.value)} value={genAISortColumn}>
        <option value="Contract ID / Opp ID">Contract ID / Opp ID</option>
        <option value="E2E ID | End To End Name">E2E ID | End To End Name</option>
        <option value="Market | MU or IG | Industry">Market | MU or IG | Industry</option>         
        <option value="CommittedScaled">Committed vs Scaled</option>
        <option value="Financial">Gen AI RAG (Committed) </option>
        <option value="People / Resources">GenAI Planned Productivity ($)</option>
        <option value="Information Security">Realized GenAI Productivity ($)</option>
      </select>
      </div> */}
      <div className="table-wrapper" id="table-wrapper">
      <table className="table table-bordered smart-table">
        <thead>
          <tr>
            {genAIcolumns.map((col) => (
              <th key={col} className="position-relative">
                <div className="d-flex align-items-center justify-content-between">
                  {col}
                  {/* {genAIDisplayCol.includes(col) && (
                  <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => handleGenAIFilterClick(col)}></i>
                )} */}
                  </div>

                {genAIModalOpen && genAIFilterColumn === col && (
                  <div
                    className="border p-2 bg-white shadow-sm position-absolute filter-popup"
                    style={{
                      top: "100%",
                      left: "0",
                      width: "250px",
                      zIndex: 1050,
                    }}
                  >
                    <div className="mb-2 fw-bold">{`Filter ${col}`}</div>
                    <div class="input-container">
                        <input
                          type="text"
                          className="form-control mb-2 input-underline"
                          placeholder="Search..."
                          value={genAISearchText}
                          class="input-underline"
                          onChange={(e) => setGenAISearchText(e.target.value)}
                        />
                        <i class="bi bi-search search-icon"></i> 
                     </div>
                    <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={genAIAllSelected}
                        onChange={handleGenAISelectAll}
                      />
                      <label className="form-check-label selectAllLabel" htmlFor="selectAll">
                        Select All
                      </label>
                    </div>
                    <hr/>
                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {getGenAIUniqueOptions().map((option, idx) => (
                        <div className="form-check" key={idx} >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            class="selectAllInput"
                            id={`check-${option}`}
                            checked={!!selectedGenAIOptions[option]}
                            onChange={() => handleGenAICheckboxChange(option)}
                          />
                          <label
                            className="form-check-label selectAllLabel"
                            htmlFor={`check-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setGenAIModalOpen(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleGenAIApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {genAIFilteredData.length > 0 ? ( genAIFilteredData.map((row, idx) => (
            <tr key={idx} className='clienttr' onClick={() => handleRowClick(row)}>
                  {genAIcolumns.map((col) => {
                    const cellValue = row[col];
                    const className = displayGenAIColumnsData(col,row[col]); // assuming "Green" or "green"
                    console.log('className',className);
                    const title = titleMap[cellValue] || '';
                    console.log('title',title);
                    
                    return (
                      <td key={col} className={cellValue} title={title}>
                        {className}
                      </td>
                    );
                  })}
            </tr>           
          ))): (
      <tr>
        <td colSpan="8" className="text-center">
          No data available
        </td>
      </tr>
    )}
        </tbody>
      </table>
      </div>
    </div>
        </div>
      {showFeedback && ( <FeedbackWidget moduleName="client_demographics_web" onSubmit={() => setShowFeedback(false)}/>)}
      <div className="footerText">Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.</div>
  </div>
    {loading && <Loader />} 
    </Container> 
    </div>
  );
};

export default Client;
